__turbopack_context__.v({
  "className": "syne_a730de70-module__h5FVha__className",
});
